import React from 'react';
import { IMAGE_DATABASE } from 'src/data';
import './Gallery.css';

export const Gallery = ({ openViewHandler }) => {
  return (
    <section className='lnl-gallery row my-1'>
      {IMAGE_DATABASE.map((imageObj) => {
        return (
          <div
            className='gallery-tile'
            onClick={() => openViewHandler(imageObj)}
            key={imageObj.name}
          >
            <img src={imageObj.thumbnail} className='lnl-img' alt={imageObj.name} />
            <caption className='img-caption'>{imageObj.name}</caption>
          </div>
        );
      })}
    </section>
  );
};
